(function () {
  var BRINDE_VARIANT_ID = 46441925607585;
  var CALCA_HANDLES = [
    'calca-modeladora-malha-fittform-prada',
    'calca-modeladora-afina-cintura-jeans-fittform-wide',
  ];

  var syncing = false;

  function refreshCartDrawer() {
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    fetch(cartUrl + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var html = new DOMParser().parseFromString(text, 'text/html');

        ['cart-drawer-items', '.cart-drawer__footer'].forEach(function (sel) {
          var target = document.querySelector(sel);
          var source = html.querySelector(sel);
          if (target && source) target.replaceWith(source);
        });

        var iconTarget = document.getElementById('cart-icon-bubble');
        var iconSource = html.getElementById('cart-icon-bubble');
        if (iconTarget && iconSource) iconTarget.innerHTML = iconSource.innerHTML;
      })
      .catch(function (e) { console.error('[brinde-calcinha] refresh:', e); });
  }

  function syncBrinde() {
    if (syncing) return;
    syncing = true;

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        var hasCalca = items.some(function (i) { return CALCA_HANDLES.includes(i.handle); });
        var brindeItem = items.find(function (i) { return i.variant_id === BRINDE_VARIANT_ID; });

        if (hasCalca && !brindeItem) {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: BRINDE_VARIANT_ID, quantity: 1 }] }),
          }).then(function () { refreshCartDrawer(); });
        } else if (!hasCalca && brindeItem) {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: BRINDE_VARIANT_ID, quantity: 0 }),
          }).then(function () { refreshCartDrawer(); });
        }
      })
      .catch(function (e) { console.error('[brinde-calcinha]', e); })
      .finally(function () { syncing = false; });
  }

  // Intercept fetch to catch any cart modification, regardless of theme internals
  var _fetch = window.fetch;
  window.fetch = function (resource, init) {
    var url = typeof resource === 'string' ? resource : (resource && resource.url) || '';
    var promise = _fetch.apply(this, arguments);

    if (/\/cart\/(add|change|update)\.js/.test(url) && !syncing) {
      promise.then(function (response) {
        if (response.ok) setTimeout(syncBrinde, 300);
      }).catch(function () {});
    }

    return promise;
  };
})();
